import { initNavigation } from './modules/navigation';
import { initLazyLoading } from './modules/lazy-loading';
import { fetchPosts } from './modules/fetch-posts';
import { initCarousel } from './modules/carousel';
import { initModal } from './modules/modal';
import { initAnimations } from './modules/animations';
import { initTestimonialFeature } from './modules/testimonial-feature';
import { initShare } from './modules/share';
import { initFAQSearch } from './modules/faq-search';


console.log('✅ Javascript connected');

initNavigation();
initLazyLoading();
fetchPosts();
initCarousel();
initModal();
initAnimations();
initTestimonialFeature();
initShare();
initFAQSearch();
